// Language-in-URL helpers shared by the app router, i18n and SEO.
export const PREFIX = { en: "", hi: "/hi", hinglish: "/hinglish" };
export const HTML_LANG = { en: "en", hi: "hi", hinglish: "hi-Latn" };
const PUBLIC = [/^\/$/, /^\/assessment$/, /^\/programs(\/[^/]+)?$/, /^\/learn(\/[^/]+)?$/, /^\/learn\/article\/[^/]+$/, /^\/community$/,
  /^\/community\/question\/[^/]+$/, /^\/(about|privacy|terms|grievance|medical-disclaimer)$/];

export function stripLang(path) {
  const m = path.match(/^\/(hi|hinglish)(\/.*)?$/);
  return m ? m[2] || "/" : path;
}

export const isPublicPath = (path) => PUBLIC.some((r) => r.test(stripLang(path).replace(/(.)\/$/, "$1")));

// Language decided by the URL on public pages; null on logged-in app pages.
export function urlLang(path) {
  const m = path.match(/^\/(hi|hinglish)(\/|$)/);
  if (m) return m[1];
  return isPublicPath(path) ? "en" : null;
}

export function withLang(path, lang) {
  const base = stripLang(path);
  if (!isPublicPath(base) || !PREFIX[lang]) return base;
  return base === "/" ? PREFIX[lang] : PREFIX[lang] + base;
}
